import api from './axiosConfig';

export interface Ward {
  id: string;
  ward_number: string;
  created_at: string;
}

export interface Town {
  id: string;
  town: string;
  created_at: string;
}

export const locationService = {
  /**
   * Get all wards
   */
  getWards: async (): Promise<Ward[]> => {
    const response = await api.get('/locations/wards');
    // Sort wards by ward_number in ascending order
    return response.data.sort((a: Ward, b: Ward) => {
      return parseInt(a.ward_number) - parseInt(b.ward_number);
    });
  },

  /**
   * Get all towns
   */
  getTowns: async (): Promise<Town[]> => {
    const response = await api.get('/locations/towns');
    return response.data;
  },
}; 